// utils/api.js

// Función de utilidad para realizar solicitudes con fetch
export const fetchData_original = async (url, method = 'GET', myHeaders = {} , data = null) => {
    try {
      /*var myHeaders = new Headers();
      if(Token !== ""){
        myHeaders.append("Content-Type",  'application/json');  
        myHeaders.append("Authorization",  ('Bearer '+Token) );
      } */
 
      const options = {
        method,
        headers: myHeaders,
        // Incluye el cuerpo de la solicitud si es una solicitud POST o PUT
        body: data? JSON.stringify(data) : null,
      };
      
      const controller = new AbortController();
      options.signal = controller.signal; 

      setTimeout(() => {controller.abort(); return "Se precento un problema en la conexión a internet.";} , 10000);

      const response = await fetch(url, options);
  
      if (!response.ok) {
        // Si la respuesta no es exitosa, lanza un error
        //throw new Error(`Error: ${response.status}`); 
        return(response); 
      }else{
        // Si la respuesta es exitosa, devuelve los datos en formato JSON
        return await response.json();
      }
  
    } catch (error) {
      // Captura y maneja errores durante la solicitud
      //console.error('Error al realizar la solicitud:', error.message);
      return('Error al realizar la solicitud:', error);
      ///throw error.message; // Puedes elegir manejar el error de otra manera si lo prefieres
    }
};

// utils/api.js*/

export const fetchData_viejo = async (url, method = 'GET', myHeaders = {} , data = null, fetch_timeOut = 120000) => {
  try {
    /*var myHeaders = new Headers();
    if(Token !== ""){
      myHeaders.append("Content-Type",  'application/json');  
      myHeaders.append("Authorization",  ('Bearer '+Token) );
    } */

    const options = {
      method,
      headers: myHeaders,
      // Incluye el cuerpo de la solicitud si es una solicitud POST o PUT
      body: data? JSON.stringify(data) : null,
    };
    
    const controller = new AbortController();
    options.signal = controller.signal; 

    setTimeout(
      () => {
        controller.abort();
        //return "Failed to fetch";
        return {code:-3, msg:"Se agoto el tiempo de la petición."};
      } , fetch_timeOut
    );
    ///setTimeout(() => {controller.abort(); return "Se agoto el tiempo de espera de la peticion."} , fetch_timeOut);
    const response = await fetch(url, options);

    if (!response.ok) {
      // Si la respuesta no es exitosa, lanza un errors
      //throw new Error(`Error: ${response.status}`); 
      return(response); 
    }else{
      // Si la respuesta es exitosa, devuelve los datos en formato JSON
      return await response.json();
    }

  } catch (error) {
    // Captura y maneja errores durante la solicitud
    //console.error('Error al realizar la solicitud:', error.message);
    return('Error al realizar la solicitud:', error +"asdasd");
    ///throw error.message; // Puedes elegir manejar el error de otra manera si lo prefieres
  }
};
/**/ 
export const fetchData = async (url, method = 'GET', myHeaders = {}, data = null, fetch_timeOut = 120000) => {
  try {
    const options = {
      method,
      headers: myHeaders,
      body: data ? JSON.stringify(data) : null,
    };
    
    const controller = new AbortController();
    options.signal = controller.signal; 

    // Crea un timeout que abortará la solicitud después de fetch_timeOut milisegundos
    const timeout = setTimeout(() => {
      controller.abort();
    }, fetch_timeOut);

    const response = await fetch(url, options);

    clearTimeout(timeout); // Cancela el timeout si la solicitud se completa a tiempo

    if (!response.ok) {
      // Si la respuesta no es exitosa, lanza un error detallado
      return { code: response.status, msg: `Error: ${response.statusText}` };
    } else {
      // Si la respuesta es exitosa, devuelve los datos en formato JSON
      return await response.json();
    }

  } catch (error) {
    if (error.name === 'AbortError') {
      return { code: -3, msg: "Se agotó el tiempo de la petición." };
    }
    else if (error.message === 'Failed to fetch') {
      return { code: -4, msg: "Por favor revise su conexión a internet." };
    }else{
      return { code: -5, msg: `Error desconocido: `+ error.message };
    }
    
  }
};


// Función de utilidad para realizar solicitudes con fetch
export const fetchDataAPI = async (url, method = 'GET', data = null,Token="") => {
  try {
    const options = {
      method,
      
      headers: {   
      },
      //mode: "same-origin",
      // Incluye el cuerpo de la solicitud si es una solicitud POST o PUT
      body: data? JSON.stringify(data) : null,
    };

    const response = await fetch(url, options);

    if (!response.ok) {
      // Si la respuesta no es exitosa, lanza un error
      //throw new Error(`Error: ${response.status}`); 
      return(response); 
    }else{
      // Si la respuesta es exitosa, devuelve los datos en formato JSON
      return await response.json();
    }

  } catch (error) {
    // Captura y maneja errores durante la solicitud
    //console.error('Error al realizar la solicitud:', error.message);
    return('Error al realizar la solicitud:', error.message);
    ///throw error.message; // Puedes elegir manejar el error de otra manera si lo prefieres
  }
};